import { render } from "./NavbarTwoSafest.vue?vue&type=template&id=56c873a1"
import script from "./NavbarTwoSafest.vue?vue&type=script&lang=js"
export * from "./NavbarTwoSafest.vue?vue&type=script&lang=js"

import "./NavbarTwoSafest.vue?vue&type=style&index=0&id=56c873a1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__